import { OnboardingFormFields } from '@Types/index';

export const UBO_INDEX_TO_FIELD_NAME = [
  OnboardingFormFields.OWNER_CENTER_UBO_1_PERCENTAGE,
  OnboardingFormFields.OWNER_CENTER_UBO_2_PERCENTAGE,
  OnboardingFormFields.OWNER_CENTER_UBO_3_PERCENTAGE,
  OnboardingFormFields.OWNER_CENTER_UBO_4_PERCENTAGE,
] as const;
